import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

import { Experiment } from '../../constants';
import type { MenuData } from '../../types';
import { getIsEditor3 } from '../../utils';
import { globalAppState } from '../services';
import { BUILDER_MENU_ITEM_TYPE } from './constants';
import { refreshApp } from './document';

export const getMenu = async (editorSDK: FlowEditorSDK, menuId: string) => {
  const menuData = await editorSDK.menu.getById('', { menuId });
  return menuData as MenuData;
};

export const updateMenu = async (
  editorSDK: FlowEditorSDK,
  menuId: string,
  menuData: MenuData,
) => {
  const flowAPI = globalAppState.getFlowAPI();

  if (getIsEditor3()) {
    menuData.items = menuData.items.map(({ isVisibleMobile, ...itemRest }) => ({
      ...itemRest,
      type: BUILDER_MENU_ITEM_TYPE,
    }));
  }

  await editorSDK.menu.update('', { menuId, menuData });

  if (
    flowAPI?.experiments.enabled(Experiment.VerticalDeletionRemoveRefreshApp)
  ) {
    return;
  }

  return refreshApp(editorSDK);
};
